<script>
import BaseView from "@/mixins/BaseView.vue";
import SearchField from "@/components/inputs/SearchField.vue";
import TableFilterRow from "@/components/tables/TableFilterRow.vue";
import TableFilter from "@/components/tables/TableFilter.vue";
import { defineComponent } from "vue";
import { phoneMask } from "@/constants/mask.ts";
import PhoneField from "@/components/inputs/PhoneField.vue";

export default defineComponent({
  name: "CoordinatorsSearchForm",
  components: { PhoneField, TableFilter, TableFilterRow, SearchField },
  mixins: [BaseView],
  emits: ["search"],
  data() {
    return {
      params: {},
    };
  },
  computed: {
    phoneMask() {
      return phoneMask;
    },
  },
  created() {
    this.params = this.getSearchParams("coordinators");
    this.search();
  },
  methods: {
    clear() {
      this.params = {};
      this.search();
    },
    search() {
      this.setSearchParams("coordinators", this.params);
      this.$emit("search", this.params);
    },
  },
});
</script>

<template>
  <table-filter :expandable="false" @apply="search" @clear="clear">
    <template #header>
      <table-filter-row :divider="false" :label="$t('general.filter-main')" icon="mdi-filter-variant">
        <v-col>
          <search-field id="search--name-field" v-model="params.name" :label="$t('general.name')" @search="search" />
        </v-col>
        <v-col>
          <phone-field v-model="params.phone" @search="search" />
        </v-col>
        <v-col>
          <search-field
            id="search--email-field"
            v-model="params.email"
            :label="$t('general.email')"
            type="email"
            @search="search"
          />
        </v-col>
      </table-filter-row>
    </template>
  </table-filter>
</template>
